'use strict';

/**
 * Services that persists and retrieves TODOs from localStorage.
 */

angular.module('tdl.services.storage').factory('ConfigService', ['$resource', 'Conf', 'TDLAuth',
 function ($resource, Conf, TDLAuth) {

    return $resource(Conf.api + '/config', {}, {
      get: {
        method: 'GET',
        isArray: false
      }
    });
 }]);